export const attackers = [
	{
		name: "Striker",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2ZC6qMkmnam9bLc1fZJJ0C/fd0719a5b03789e65aa7f41e7c2dc49c/r6s-operators-badge-striker.png",
		weapons: {
			primaryWeapon: [
				"M4",
				"M249",
				"SR-25"
			],
			secondaryWeapon: [
				"5.7 USG",
				"ITA12S"
			],
		},
		hability: [
			"Breach Charge",
			"Claymore",
			"Frag Grenade",
			"Hard Breach Charge"
		],
		gadget: [
			"Smoke Grenade",
			"Stunt Grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Sledge",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4lgK1mOTVAoBhoj5qjYuyd/83c83d56e977f96ac0e9621c0d1c07d2/Y0R6_BADGE_Sledge_L.png",
		weapons: {
			primaryWeapon: [
				"L85A2",
				"M590A1"
			],
			secondaryWeapon: [
				"P226 MK 25",
				"REAPER MK2",
			],
		},
		hability: ["Breaching Hammer"],
		gadget: [
			"Frag Grenade",
			"Stunt Grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Thatcher",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5NbqTdEPmYy9qOZmN9StVT/f75b0f2610a37f9e5bdcb8ba9d551a38/Y0R6_BADGE_Thatcher_L.png",
		weapons: {
			primaryWeapon: [
				"AR33",
				"L85A2",
				"M590A1",
				"PMR90A2",
			],
			secondaryWeapon: [
				"P226 MK 25",
			],
		},
		hability: ["E.G.S. Disruptor (Electronic Gear Scanner Disruptor)"],
		gadget: [
			"Breach Charge",
			"Claymore",
		]
	},
	{
		name: "Ash",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/58Y4Q2x7msL8uQUoiA7LGM/b204acc9c5a015029140723ef2e435bb/Y0R6_BADGE_Ash_L.png",
		weapons: {
			primaryWeapon: [
				"G36C",
				"R4-C"
			],
			secondaryWeapon: [
				"5.7 USG",
				"M45 MEUSOC",
			],
		},
		hability: ["Breaching Round"],
		gadget: [
			"Breach Charge",
			"Claymore",
		]
	},
	{
		name: "Thermite",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6tow5mqLao5TrJVL52csSc/46aa934c9f3f02189e9c04df0114a081/Y0R6_BADGE_Thermite_L.png",
		weapons: {
			primaryWeapon: [
				"M1014",
				"556XI"
			],
			secondaryWeapon: [
				"5.7 USG",
				"M45 MEUSOC",
				"ITA12S"
			],
		},
		hability: ["Exothermic Charge"],
		gadget: [
			"Smoke grenade",
			"Stunt Grenade",
		]
	},
	{
		name: "Twitch",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3YgCpOSM2R4SDgExstxm7P/ff84e6ac53bd9f690deee78870f9c23b/Y0R6_BADGE_Twitch_L.png",
		weapons: {
			primaryWeapon: [
				"F2",
				"417",
				"SG-CQB"
			],
			secondaryWeapon: [
				"P9",
				"LFP586"
			],
		},
		hability: ["Shock Drone"],
		gadget: [
			"Smoke grenade",
			"Claymore"
		]
	},
	{
		name: "Montagne",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7qWONT0mrNYtUZVTVVT8Yj/e0da552d6bb6548ddf74cf4cc44d75c5/Y0R6_BADGE_Montagne_L.png",
		weapons: {
			primaryWeapon: [
				"LE ROC SHIELD",
			],
			secondaryWeapon: [
				"P9",
				"LFP586"
			],
		},
		hability: ["LE ROC SHIELD"],
		gadget: [
			"Hard breach charge",
			"Smoke grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Glaz",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5UAZVgyOutPh6bLTV3fGXf/c59d484fd599d09a947ec423b2119620/Y0R6_BADGE_Glaz_L.png",
		weapons: {
			primaryWeapon: [
				"OTS-03",
			],
			secondaryWeapon: [
				"PMM",
				"GONNE-6",
				"Bearing 9"
			],
		},
		hability: ["Flip Sight"],
		gadget: [
			"Smoke grenade",
			"Frag Grenade",
			"Claymore"
		]
	},
	{
		name: "Fuze",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1wkdQ0viuTEguji14qXMJG/5858418baa8cca04a6e42a2d6256c093/Y0R6_BADGE_Fuze_L.png",
		weapons: {
			primaryWeapon: [
				"AK-12",
				"6P41",
				"Ballistic Shield"
			],
			secondaryWeapon: [
				"PMM",
				"GSH-18",
			],
		},
		hability: ["Cluster Charge"],
		gadget: [
			"Breach Charge",
			"Hard breach charge",
			"Smoke grenade"
		]
	},
	{
		name: "Blitz",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2YTGfm1Df9PtldLcGodcTV/9a235b550cdf5066d686cef750eba090/Y0R6_BADGE_Blitz_L.png",
		weapons: {
			primaryWeapon: [
				"G52-Tactical Shield",
			],
			secondaryWeapon: [
				"P12",
			],
		},
		hability: ["G52-Tactical Shield"],
		gadget: [
			"Smoke grenade",
			"Breach Charge",
		]
	},
	{
		name: "IQ",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4xnVj2iZB8Otchiw7j69UO/13c864a4e2eb976c1978dc79411b450c/Y0R6_BADGE_IQ_L.png",
		weapons: {
			primaryWeapon: [
				"AUG A2",
				"552 Commando",
				"G8A1"
			],
			secondaryWeapon: [
				"P12",
			],
		},
		hability: ["Electronics Detector"],
		gadget: [
			"Breach Charge",
			"Frag Grenade",
			"Claymore"
		]
	},
	{
		name: "Buck",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2oZZBEZzVLFpRY7Mp85MWq/f62287872dd61b4e0697a93d703b2beb/Y1S1_BADGE_Buck_L.png",
		weapons: {
			primaryWeapon: [
				"C8-SFW",
				"CAMRS"
			],
			secondaryWeapon: [
				"MK1 9MM"
			],
		},
		hability: ["Skeleton key"],
		gadget: [
			"Stunt grenade",
			"Claymore"
		]
	},
	{
		name: "Blackbeard",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4BTbmcs1EtoUbnpk5Am22Y/b7bd4d0708245c78b98455505c0d51a8/Y1S2_BADGE_Blackbeard_L.png",
		weapons: {
			primaryWeapon: [
				"MK17 CQB",
				"SR-25"
			],
			secondaryWeapon: [
			],
		},
		hability: ["H.U.L.L. Adaptable shield"],
		gadget: [
			"Frag Grenade",
			"Claymore"
		]
	},
	{
		name: "Capitao",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/73R4IrWJyn0xdkJ0fjOODA/fc70d200a7530dccae2847ab7962e394/Y1S3_BADGE_Capitao_L.png",
		weapons: {
			primaryWeapon: [
				"M249",
				"PARA-308",
				"PMR90A2",
			],
			secondaryWeapon: [
				"GONNE-6",
				"PRB92",
			],
		},
		hability: ["Tactical Crossbow"],
		gadget: [
			"Claymore",
			"Hard Breach Charge",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Hibana",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1TSA4pMR58vgfrEai69REl/f82b1eba6694b4aa77259d3d0fe8cc08/Y1S4_BADGE_Hibana_L.png",
		weapons: {
			primaryWeapon: [
				"Supernova",
				"TYPE-89",
				"PMR90A2",
			],
			secondaryWeapon: [
				"Bearing 9",
				"P229",
			],
		},
		hability: ["X-Kairos"],
		gadget: [
			"Stunt grenade",
			"Breach Charge",
			"Claymore",
		]
	},
	{
		name: "Jackal",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/28k7LKWK70lxib7CimPJaZ/f34b2065811df8f0339838922f8c94b1/Y2S1_BADGE_Jackal_L.png",
		weapons: {
			primaryWeapon: [
				"C7E",
				"PDW9",
				"ITA12L",
			],
			secondaryWeapon: [
				"USP40",
				"ITA12S",
			],
		},
		hability: ["Eyenox Model III"],
		gadget: [
			"Claymore",
			"Smoke Grenade"
		]
	},
	{
		name: "Ying",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6ZVB1OJxNgs0pR0Fd7Kzt0/74721fe9fd743167508f98dc280a17a3/Y2S2_BADGE_Ying_L.png",
		weapons: {
			primaryWeapon: [
				"T-95 LSW",
				"SIX12"
			],
			secondaryWeapon: [
				"Q-929",
				"REAPER MK2",
			],
		},
		hability: ["Candela"],
		gadget: [
			"Hard breach charge",
			"Smoke grenade"
		]
	},
	{
		name: "Zofia",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1k09nbCCu2avlIWpK3cJz9/35d60746d67750230f2a020a7be78795/Y2S3_BADGE_Zofia_L.png",
		weapons: {
			primaryWeapon: [
				"LMG-E",
				"M762"
			],
			secondaryWeapon: [
				"RG15",
			],
		},
		hability: ["KS79 Lifeline"],
		gadget: [
			"Claymore",
			"Hard Breach Charge",
		]
	},
	{
		name: "Dokkaebi",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/aoQeHLohcuqvubBoyrzsM/d4a230ecba495c58c5521e10d5d84baa/Y2S4_BADGE_Dokkaebi_L.png",
		weapons: {
			primaryWeapon: [
				"MK 14 EBR",
				"BOSG.12.2"
			],
			secondaryWeapon: [
				"GONNE-6",
				"SMG-12",
				"C75 AUTO"
			],
		},
		hability: ["Logic Bomb"],
		gadget: [
			"Smoke Grenade",
			"Stunt Grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Lion",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3gfdjXFezusaerCakMpfQ2/4565b28edd241b7fd3b0eba9c97d54f2/Y3S1_BADGE_Lion_L.png",
		weapons: {
			primaryWeapon: [
				"417",
				"SG-CQB",
				"V308"
			],
			secondaryWeapon: [
				"LFP586",
				"P9"
			],
		},
		hability: ["EE-ONE-D"],
		gadget: [
			"Claymore",
			"Frag Grenade",
			"Stunt Grenade"
		]
	},
	{
		name: "Finka",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6CzQHWePD3Mi8HE5bdx5ic/2a6b5a6cc653ebf99d062725368eae2a/Y3S1_BADGE_Finka_L.png",
		weapons: {
			primaryWeapon: [
				"6P41",
				"SASG-12",
				"Spear .308"
			],
			secondaryWeapon: [
				"GSH-18",
				"PMM"
			],
		},
		hability: ["Adrenal Surge"],
		gadget: [
			"Frag Grenade",
			"Smoke Grenade",
			"Stunt Grenade"
		]
	},
	{
		name: "Maverick",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3DXiYgVT71qGscYmFMgayj/d6c40a7dabdfecb92b637bec83003a58/Y3S3_BADGE_Maverick_L.png",
		weapons: {
			primaryWeapon: [
				"AR-15.50",
				"M4",
			],
			secondaryWeapon: [
				"1911 TACOPS",
				"C75 AUTO",
				"REAPER MK2",
			],
		},
		hability: ["Breaching Torch"],
		gadget: [
			"Claymore",
			"Smoke Grenade",
			"Stunt Grenade",
			"Frag Grenade",
		]
	},
	{
		name: "Nomad",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/UxfU1gJDoZGDrzT3iBsIp/b1aa522cc08e4631b9a857b52afa4f99/Y3S4_BADGE_Nomad_L.png",
		weapons: {
			primaryWeapon: [
				"AK-74M",
				"ARX200",
			],
			secondaryWeapon: [
				"PRB92",
				".44 MAG SEMI-AUTO",
			],
		},
		hability: ["Airjab Launcher"],
		gadget: [
			"Breach Charge",
			"Stunt Grenade",
		]
	},
	{
		name: "Gridlock",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5LIyheUROsdMDkX6o0zh6R/f201ce65af771459c374ef71c89827b4/Y4S1_BADGE_Gridlock_LL.png",
		weapons: {
			primaryWeapon: [
				"F90",
				"M249 SAW"
			],
			secondaryWeapon: [
				"Super shorty",
				"SPD 9MM"
			],
		},
		hability: ["Trax Stingers"],
		gadget: [
			"Smoke Grenade",
			"Frag Grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "`NØKK`",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2qfSHHTdCRVhx9EWycVDNr/9e361e73fb91e571f7470de21edf5c7a/Y4S2_BADGE_Nokk_L.png",
		weapons: {
			primaryWeapon: [
				"FMG-9",
				"SIX12 SD",
				"PMR90A2",
			],
			secondaryWeapon: [
				"5.7 USG",
				"D-50",
			],
		},
		hability: ["HEL Presence Reduction"],
		gadget: [
			"Hard Breach Charge",
			"Frag Grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Amaru",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2K1uxROLvHGxOIOMpNRFeU/7b4afc5ded3d1b9a937d1b504b5d4d0d/Y4S3_BADGE_Amaru_L.png",
		weapons: {
			primaryWeapon: [
				"G8A1",
				"Supernova"
			],
			secondaryWeapon: [
				"GONNE-6",
				"SMG-11",
				"ITA12S"
			],
		},
		hability: ["Garra Hook"],
		gadget: [
			"Stunt Grenade",
			"Hard Breach Charge"
		]
	},
	{
		name: "Kali",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6r1hk1EunQirF1IcY4TG8T/0d3fbb7508a7747fd51249b1b8ea9779/Y4S4_BADGE_Kali_L.png",
		weapons: {
			primaryWeapon: [
				"CSRX 300"
			],
			secondaryWeapon: [
				"SPSMG9",
				"C75 AUTO",
				"P226 MK 25"
			],
		},
		hability: ["LV Explosive Lance"],
		gadget: [
			"Breach Charge",
			"Claymore",
			"Smoke Grenade"
		]
	},
	{
		name: "Iana",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6deSi1vse5iJTkErFksrGq/75bf1038e9698b6b2be75aa0493b092d/Y5S1_BADGE_Iana_L.png",
		weapons: {
			primaryWeapon: [
				"G36C",
				"ARX200"
			],
			secondaryWeapon: [
				"GONNE-6",
				"MK1 9MM"
			]
		},
		hability: ["Gemini replicator"],
		gadget: [
			"Impact EMP grenade",
			"Smoke grenade"
		]
	},
	{
		name: "Ace",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/dgG7GmXY1HgfeEE2gI1H9/06bd3917c8fc19f61654490019ef25fb/Y5S2_BADGE_Ace_L.png",
		weapons: {
			primaryWeapon: [
				"AK-12",
				"M1014"
			],
			secondaryWeapon: [
				"P9",
			],
		},
		hability: ["S.E.L.M.A. AQUA BREACHER"],
		gadget: [
			"Breach Charge",
			"Claymore"
		]
	},
	{
		name: "Zero",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4ZbzOZt1Sur77RZTFwYVJ4/30037e84b2948449652547f06df146e0/Y5S3_BADGE_Zero_L.png",
		weapons: {
			primaryWeapon: [
				"MP7",
				"SC3000K"
			],
			secondaryWeapon: [
				"5.7 USG",
				"GONNE-6"
			],
		},
		hability: ["ARGUS LAUNCHER"],
		gadget: [
			"Hard Breach Charge",
			"Claymore"
		]
	},
	{
		name: "Flores",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/75vqJXXKCM2EDO0iiNqRDe/d6289dc9a4fed72ef72b9c1e11738456/Y6S1_BADGE_Flores_L.png",
		weapons: {
			primaryWeapon: [
				"AR33",
				"SR-25",
				"T-95 LSW"
			],
			secondaryWeapon: [
				"GSH-18"
			],
		},
		hability: ["RCE-RATERO CHARGE"],
		gadget: [
			"Stunt Grenade",
			"Claymore"
		]
	},
	{
		name: "OSA",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5tt27EFHYjiDLo2qbYEgXG/2f1acbb8209e45b136ca7b0e2e5eb1f9/r6s-operators-badge-osa.png",
		weapons: {
			primaryWeapon: [
				"556XI",
				"PDW9"
			],
			secondaryWeapon: [
				"PMM",
			],
		},
		hability: ["TALON-8 CLEAR SHIELD"],
		gadget: [
			"Claymore",
			"Frag Grenade",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Sens",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7pqZFaPgQwaLi1pFKuAv7e/d3d9af214737fe6a069e5346c50bfd20/r6s-operators-badge-sens.png",
		weapons: {
			primaryWeapon: [
				"417",
				"POF9"
			],
			secondaryWeapon: [
				"SPD 9MM",
			],
		},
		hability: ["R.O.U. Projector System"],
		gadget: [
			"Claymore",
			"Frag Grenade",
			"Hard Breach Charge"
		]
	},
	{
		name: "Grim",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5VoAYPvRZXIwjcwTD3PWaZ/b9748f007c0c116ca1bcd77b0f91e766/r6s-operators-badge-grim.png",
		weapons: {
			primaryWeapon: [
				"552 Commando",
				"SG-CQB"
			],
			secondaryWeapon: [
				"Bailiff 410",
				"P229"
			],
		},
		hability: ["Kawan Hive Launcher"],
		gadget: [
			"Claymore",
			"Hard Breach Charge",
			"Impact EMP Grenade"
		]
	},
	{
		name: "Brava",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1JTzualMKZVGfdROg4XKh8/7989454e62b7972bfd88f09097cc148f/r6s-operators-badge-brava.png",
		weapons: {
			primaryWeapon: [
				"PARA-308",
				"CAMRS"
			],
			secondaryWeapon: [
				"USP40",
				"Super shorty"
			],
		},
		hability: ["Kludge drone"],
		gadget: [
			"Smoke grenade",
			"Claymore"
		]
	},
	{
		name: "RAM",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3YQiStwC1Qo4wKWmgK6XCH/ac8a0fea30f2996f96ca31b17a0039fa/r6s-operators-badge-ram.png",
		weapons: {
			primaryWeapon: [
				"LMG-E",
				"R4-C"
			],
			secondaryWeapon: [
				"MK1 9MM"
			],
		},
		hability: ["BU-GI AUTO BREACHER"],
		gadget: [
			"Smoke grenade",
			"Stunt Grenade"
		]
	},
	{
		name: "Deimos",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/18uYWtYnEjmMQBTTdkIfWF/ba8c07729ff3c6de5872ffbcdc7956fb/r6s-operators-badge-deimos.png",
		weapons: {
			primaryWeapon: [
				"AK-74M",
				"M590A1"
			],
			secondaryWeapon: [
				".44 Vendetta",
			],
		},
		hability: ["DEATHMARK TRACKER"],
		gadget: [
			"Frag Grenade",
			"Hard Breach Charge"
		]
	},
	{
		name: "Raurora",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/T2BrSyMgBBSjM7rs8T53b/0f8d6842d4440fc06d450789c273381b/r6s-operators-badge-rauora.png",
		weapons: {
			primaryWeapon: [
				"417",
				"M249"
			],
			secondaryWeapon: [
				"Reaper MK2",
				"GSH-18"
			],
		},
		hability: ["D.O.M. Panel Launcher"],
		gadget: [
			"Smoke grenade",
			"Breach charge"
		]
	},
	{
		name: "Solid Snake",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7l8uzV1767cot7GpTcnK7t/9be16729f34b76e97dbcbbd0a81bd74c/r6s-operators-badge-solidsnake.png",
		weapons: {
			primaryWeapon: [
				"F2",
				"PMR90A2"
			],
			secondaryWeapon: [
				"TACIT .45"
			],
		},
		hability: ["Radar Soliton Mk. III"],
		gadget: [
			"Frag Grenade",
			"Stunt Grenade",
			"Impact EMP Grenade",
			"Smoke Grenade",
			"Breach Charge"
		]
	},
]

export const defenders = [
	{
		name: "Sentry",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3RhB8rT969t71r0b3iiiQo/3bf85d17ade85b4e5943712b664b6166/r6s-operators-badge-sentry.png",
		weapons: {
			primaryWeapon: [
				"Commando 9",
				"M870",
				"TCSG12"
			],
			secondaryWeapon: [
				"C75 AUTO",
				"Super shorty"
			],
		},
		hability: [
			"Barbed Wire",
			"Bulletpoof Camera",
			"Deployable Shield",
			"Observation Blocker"
		],
		gadget: [
			"Impact Grenade",
			"Nitro Cell",
			"Proximity Alarm"
		],
	},
	{
		name: "Smoke",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6mOMxoc3t27R9Gr9wFtt6T/f5f90a6be6a6710bee686ce69df29906/Y0R6_BADGE_Smoke_L.png",
		weapons: {
			primaryWeapon: [
				"M590A1",
				"FMG-9"
			],
			secondaryWeapon: [
				"P226 MK 25",
				"SMG-11"
			],
		},
		hability: ["Remote Gas Grenade"],
		gadget: [
			"Barbed Wire",
			"Proximity Alarm"
		],
	},
	{
		name: "Mute",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3exeHnxH1tmUmQTequWRKa/e1b6c6f057eb24722dd7860af0276316/Y0R6_BADGE_Mute_L.png",
		weapons: {
			primaryWeapon: [
				"MP5K",
				"M590A1"
			],
			secondaryWeapon: [
				"P226 MK 25",
				"SMG-11"
			],
		},
		hability: ["Signal Disruptor"],
		gadget: [
			"Bulletproof camera",
			"Nitro Cell"
		],
	},
	{
		name: "Castle",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/kzznLctjOsXJZAg0F2HPB/dea28fa008515d6ddaa0d2659f4dc253/Y0R6_BADGE_Castle_L.png",
		weapons: {
			primaryWeapon: [
				"UMP45",
				"M1014"
			],
			secondaryWeapon: [
				"5.7 USG",
				"Super shorty",
				"M45 MEUSOC"
			],
		},
		hability: ["Armor panel"],
		gadget: [
			"Proximity Alarm",
			"Bulletproof camera"
		]
	},
	{
		name: "Pulse",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/ChAeJzdmwxuvhZTrV81rK/8c16116f4c719a3df864df6639e2f52e/Y0R6_BADGE_Pulse_L.png",
		weapons: {
			primaryWeapon: [
				"UMP45",
				"M1014"
			],
			secondaryWeapon: [
				"5.7 USG",
				"M45 MEUSOC",
				"REAPER MK2"
			]
		},
		hability: ["Cardiac Sensor"],
		gadget: [
			"Nitro Cell",
			"Deployable shield",
			"Observation blocker"
		]
	},
	{
		name: "Doc",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/71Nl3v0LqHyo9eXV6xTFQd/1ba4f057b6acad3ec700ca9e60b53d6c/Y0R6_BADGE_Doc_L.png",
		weapons: {
			primaryWeapon: [
				"MP5",
				"P90",
				"SG-CQB"
			],
			secondaryWeapon: [
				"P9",
				"LFP586",
				"Bailiff 410"
			],
		},
		hability: ["Stim Pistol"],
		gadget: [
			"Bulletproof camera",
			"Barbed Wire"
		],
	},
	{
		name: "Rook",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3Yk1noMd9re0RLlrXJSWtR/7a55e80593c487827293a114835dba63/Y0R6_BADGE_Rook_L.png",
		weapons: {
			primaryWeapon: [
				"MP5",
				"P90",
				"SG-CQB"
			],
			secondaryWeapon: [
				"REAPER MK2",
				"P9",
				"LFP586"
			],
		},
		hability: ["Armor Pack"],
		gadget: [
			"Proximity Alarm",
			"Impact Grenade",
			"Observation blocker"
		],
	},
	{
		name: "Kapkan",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/797q7C5YA89eFqw4RB40ka/f9435d1b4d13d41472e22d305c961cb9/Y0R6_BADGE_Kapkan_L.png",
		weapons: {
			primaryWeapon: [
				"9X19VSN",
				"SASG-12"
			],
			secondaryWeapon: [
				"PMM",
				"GSH-18"
			],
		},
		hability: ["Entry Denial Device"],
		gadget: [
			"Barbed Wire",
			"Bulletproof camera"
		],
	},
	{
		name: "Tachanka",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7hpI2mcmvyjC2vG6ieltLo/f217b1dc449c0514b55e471193a38c91/Y0R6_BADGE_Tachanka_L.png",
		weapons: {
			primaryWeapon: [
				"DP27",
				"9X19VSN",
			],
			secondaryWeapon: [
				"PMM",
				"GSH-18",
				"Bearing 9"
			],
		},
		hability: ["SHUMIKHA LAUNCHER"],
		gadget: [
			"Barbed Wire",
			"Proximity Alarm",
			"Deployable shield"
		],
	},
	{
		name: "Jager",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1cCvTmKwnnovVmpZmDyPkA/b064f5ad6b9e7398d820d9ea90ff9366/Y0R6_BADGE_Jager_L.png",
		weapons: {
			primaryWeapon: [
				"M870",
				"416-C Carbine"
			],
			secondaryWeapon: [
				"P12"
			],
		},
		hability: ["ACTIVE DEFENSE"],
		gadget: [
			"Bulletproof camera",
			"Observation blocker"
		],
	},
	{
		name: "Bandit",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4Vasjq82J1TNjNE38J7LmV/e1725f8d9ea2b85565e40b54faac85b8/Y0R6_BADGE_Bandit_L.png",
		weapons: {
			primaryWeapon: [
				"MP7",
				"M870"
			],
			secondaryWeapon: [
				"P12",
			],
		},
		hability: ["Shock Wire"],
		gadget: [
			"Barbed Wire",
			"Nitro Cell"
		],
	},
	{
		name: "Frost",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1OWFtfiEXleLSENciCSQQR/8fcced59c0125073e506f2dee0201015/Y1S1_BADGE_Frost_L.png",
		weapons: {
			primaryWeapon: [
				"SUPER 90",
				"9MM C1"
			],
			secondaryWeapon: [
				"MK1 9MM",
				"ITA12S",
			],
		},
		hability: ["Welcome Mat"],
		gadget: [
			"Bulletproof camera",
			"Deployable shield"
		],
	},
	{
		name: "Valkyrie",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/44qXJmZmAwaD4w44JnPuOx/c54c8b9d3a6813ab8ce3e3f1dd4ef408/Y1S2_BADGE_Valkyrie_L.png",
		weapons: {
			primaryWeapon: [
				"MPX",
				"SPAS-12"
			],
			secondaryWeapon: [
				"D50"
			],
		},
		hability: ["Black Eye"],
		gadget: [
			"Impact Grenade",
			"Nitro Cell",
		],
	},
	{
		name: "Caveira",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4H1dOkcdZIKblKkAWjD390/10e57f4829eabda30f4aa1044e49893d/Y1S3_BADGE_Caveira_L.png",
		weapons: {
			primaryWeapon: [
				"M12",
				"SPAS-15"
			],
			secondaryWeapon: [
				"Luison",
			],
		},
		hability: ["Silent Step"],
		gadget: [
			"Proximity Alarm",
			"Impact Grenade",
			"Observation blocker"
		],
	},
	{
		name: "Echo",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3MRqAdUybJ7GR9gX4wPAI4/992938a70a4e53b91478358634e77ca7/Y1S4_BADGE_Echo_L.png",
		weapons: {
			primaryWeapon: [
				"MP5SD",
				"Supernova"
			],
			secondaryWeapon: [
				"Bearing 9",
				"P229"
			],
		},
		hability: ["Yokai"],
		gadget: [
			"Impact grenade",
			"Deployable shield"
		]
	},
	{
		name: "Mira",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/u1KR6aogjLncAtaVOciTc/ba730583f9c20cad6d3ca996d366a707/Y2S1_BADGE_Mira_L.png",
		weapons: {
			primaryWeapon: [
				"Vector .45 ACP",
				"ITA12L"
			],
			secondaryWeapon: [
				"USP40",
				"ITA12S",
			],
		},
		hability: ["Black mirror"],
		gadget: [
			"Proximity Alarm",
			"Nitro Cell"
		],
	},
	{
		name: "Lesion",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2CWYSySnPAhsOHdq2OLSjv/f9e54debcfa0c8fe76012d9097b98e6e/Y2S2_BADGE_Lesion_L.png",
		weapons: {
			primaryWeapon: [
				"SIX12 SD",
				"T-5 SMG"
			],
			secondaryWeapon: [
				"Q-929",
				"Super shorty"
			],
		},
		hability: ["GU"],
		gadget: [
			"Impact Grenade",
			"Bulletproof Camera",
		],
	},
	{
		name: "Ela",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7zbkJJWMCOj04DNhYDz994/d2cba213d30d7b8cf2ba8cd568c78f20/Y2S3_BADGE_Ela_L.png",
		weapons: {
			primaryWeapon: [
				"Scorpion EVO 3 A1",
				"FO-12"
			],
			secondaryWeapon: [
				"RG15"
			]
		},
		hability: ["Grzmot mine"],
		gadget: [
			"Barbed Wire",
			"Deployable shield",
			"Impact Grenade"
		]
	},
	{
		name: "Vigil",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/56A3hXhWZdwO623g3ejeku/a40a0582a7841abfeed723d8fbe238d3/Y2S4_BADGE_Vigil_L.png",
		weapons: {
			primaryWeapon: [
				"K1A",
				"BOSG.12.2"
			],
			secondaryWeapon: [
				"C75 AUTO",
				"SMG-12"
			],
		},
		hability: ["ERC-7"],
		gadget: [
			"Bulletproof Camera",
			"Impact Grenade"
		],
	},
	{
		name: "Maestro",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/XK43imgD0tc0xrk0tgTCQ/0402cc95cbd525debafa1aab0fdd8385/Y3S2_BADGE_Maestro_L.png",
		weapons: {
			primaryWeapon: [
				"ALDA 5.56",
				"ACS12"
			],
			secondaryWeapon: [
				"Keratos .357",
				"Bailiff 410"
			],
		},
		hability: ["Evil Eye"],
		gadget: [
			"Barbed Wire",
			"Impact Grenade",
			"Observation blocker"
		],
	},
	{
		name: "Alibi",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3DgGV3hETnXiEvVFOYZrbm/55a6be47761b5cf2c7ff8aaa7991cc7f/Y3S2_BADGE_Alibi_L.png",
		weapons: {
			primaryWeapon: [
				"Mx4 Storm",
				"ACS12"
			],
			secondaryWeapon: [
				"Keratos .357",
				"Bailiff 410"
			],
		},
		hability: ["Prisma"],
		gadget: [
			"Proximity Alarm",
			"Observation blocker"
		],
	},
	{
		name: "Clash",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7G4lGl5HPLFTTUdcZW8UOK/3901b44cf2a9423486ffd78531e42f87/Y3S3_BADGE_Clash_L.png",
		weapons: {
			primaryWeapon: [
				"CCE Shield",
			],
			secondaryWeapon: [
				"P-10C",
				"SPSMG9",
				"Super shorty"
			],
		},
		hability: ["CCE Shield"],
		gadget: [
			"Barbed Wire",
			"Deployable Shield",
			"Impact Grenade"
		],
	},
	{
		name: "Kaid",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5Qblb1ZqAqkN3Wa0Qw5qBq/05630c80672105a1195282d276e8eb05/Y3S4_BADGE_L.png",
		weapons: {
			primaryWeapon: [
				"AUG A3",
				"TCSG12"
			],
			secondaryWeapon: [
				".44 MAG SEMI-AUTO",
				"LFP586"
			],
		},
		hability: ["\"Rtila\" Electroclaw"],
		gadget: [
			"Barbed Wire",
			"Nitro Cell",
			"Observation Blocker"
		],
	},
	{
		name: "Mozzie",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/15hUu2PsypX2c1LIJFQNUT/8538c52057420dbf3995cf3117b155c5/Y4S1_BADGE_Mozzie_L.png",
		weapons: {
			primaryWeapon: [
				"Commando 9",
				"P10 Roni"
			],
			secondaryWeapon: [
				"SPD 9MM",
				"Super shorty"
			],
		},
		hability: ["Pest Launcher"],
		gadget: [
			"Barbed Wire",
			"Nitro Cell",
			"Impact Grenade"
		],
	},
	{
		name: "Warden",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/hx1Ljf1qIWbjpgCNmfJbu/2217283b569ef316dc12b93e86649f8f/Y4S2_BADGE_Warden_L.png",
		weapons: {
			primaryWeapon: [
				"M590A1",
				"MPX"
			],
			secondaryWeapon: [
				"P-10C",
				"SMG-12"
			],
		},
		hability: ["Glance Smart Glasses"],
		gadget: [
			"Deployable Shield",
			"Nitro Cell",
			"Observation Blocker"
		],
	},
	{
		name: "Goyo",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6AAY4FZt5piHdabOdDokE4/f7f8bd90c20b8a429c78a08684b75aca/Y4S3_BADGE_Goyo_L.png",
		weapons: {
			primaryWeapon: [
				"Vector .45 ACP",
				"TCSG12"
			],
			secondaryWeapon: [
				"P229"
			],
		},
		hability: ["Volcán Canister"],
		gadget: [
			"Proximity Alarm",
			"Bulletpoof Camera",
			"Impact Grenade"
		],
	},
	{
		name: "Wamai",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1vQZ4WsAjhc6M7qNOS4ahQ/92fc4d89632fb87aec0f102d7adbfe26/Y4S4_BADGE_Wamai_L.png",
		weapons: {
			primaryWeapon: [
				"AUG A2",
				"MP5K"
			],
			secondaryWeapon: [
				"Super shorty",
				"P12",
				"Keratos .357"
			],
		},
		hability: ["Mag-net System"],
		gadget: [
			"Proximity Alarm",
			"Impact Grenade"
		],
	},
	{
		name: "Oryx",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7mLA8GY9ZKlUfDXrfo9Nek/e3dfd0759414f36866a8c80b61a67722/Y5S1_BADGE_Oryx_L.png",
		weapons: {
			primaryWeapon: [
				"SPAS-12",
				"T-5 SMG"
			],
			secondaryWeapon: [
				"Bailiff 410",
				"REAPER MK2",
				"USP40"
			],
		},
		hability: ["REMAH DASH"],
		gadget: [
			"Barbed Wire",
			"Proximity Alarm"
		],
	},
	{
		name: "Melusi",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/74H52a9GMql8wamIy6WqH5/9fddba49258152835da7cdac8c566663/Y5S2_BADGE_Melusi_L.png",
		weapons: {
			primaryWeapon: [
				"MP5",
				"Super 90"
			],
			secondaryWeapon: [
				"ITA12S",
				"RG15"
			],
		},
		hability: ["Banshee Sonic Defense"],
		gadget: [
			"Bulletproof Camera",
			"Impact Grenade"
		],
	},
	{
		name: "Aruni",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5rOLCYQOh5HH0Nv6NHe38H/29681f901ff71ae5decb5ccb1b9f8a29/Y5S4_BADGE_Aruni_L.png",
		weapons: {
			primaryWeapon: [
				"P10 Roni",
				"MK 14 EBR"
			],
			secondaryWeapon: [
				"PRB92",
			],
		},
		hability: ["Surya Gate"],
		gadget: [
			"Bulletproof Camera",
			"Barbed Wire"
		],
	},
	{
		name: "Thunderbird",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/YQfDJ42B2IKcKnb0lRaXq/0cedb53c439b0fe448be95713a836b29/r6s-operators-badge-thunderbird.png",
		weapons: {
			primaryWeapon: [
				"SPAS-15",
				"SPEAR .308"
			],
			secondaryWeapon: [
				"Bearing 9",
				"Q-929",
				"ITA12S"
			],
		},
		hability: ["Kóna Station"],
		gadget: [
			"Barbed Wire",
			"Bulletproof Camera",
			"Deployable Shield"
		],
	},
	{
		name: "Thorn",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/1pzBJsbL1vQT8is7B0Xjxz/440335c080e54ca28eba24858361a03a/r6s-operators-badge-thorn.png",
		weapons: {
			primaryWeapon: [
				"UZK50GI",
				"M870"
			],
			secondaryWeapon: [
				"1911 TACOPS",
				"C75 AUTO"
			],
		},
		hability: ["RAZORBLOOM SHELL"],
		gadget: [
			"Deployable Shield",
			"Barbed Wire"
		],
	},
	{
		name: "Azami",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7KWTXHTk8rxLS5qtyX4Xu4/b51f8691b932fd2b83260ef3fbcd1154/r6s-operators-badge-azami.png",
		weapons: {
			primaryWeapon: [
				"9X19SVN",
				"ACS12"
			],
			secondaryWeapon: [
				"D-50"
			]
		},
		hability: ["kiba Barrier"],
		gadget: [
			"Impact Grenade",
			"Barbed Wire"
		]
	},
	{
		name: "Solis",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6YOBUP5JMskklFx9nDJQ49/d9d4b0968f581597feaa0ef4ec0891f3/r6s-operators-badge-solis.png",
		weapons: {
			primaryWeapon: [
				"ITA12L",
				"P90"
			],
			secondaryWeapon: [
				"SMG-11"
			],
		},
		hability: ["Spec-IO Electro-Sensor"],
		gadget: [
			"Bulletproof Camera",
			"Proximity Alarm"
		],
	},
	{
		name: "Fenrir",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4vtvBhY56S2slW3y0eKsMp/6a0f41807549ad1aa503112d4ad05a52/r6s-operators-badge-fenrir.png",
		weapons: {
			primaryWeapon: [
				"MP7",
				"SASG-12"
			],
			secondaryWeapon: [
				"5.7 USG",
				"Bailiff 410"
			],
		},
		hability: ["F-Natt Dread Mine"],
		gadget: [
			"Bulletproof Camera",
			"Observation blocker"
		],
	},
	{
		name: "Tubarao",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/43VtYmfmTtLwwKDGhalSCO/9673bb50e981ba2684cd649534f00de7/r6s-operators-badge-tubarao.png",
		weapons: {
			primaryWeapon: [
				"MPX",
				"AR-15.50",
			],
			secondaryWeapon: [
				"P226 MK 25",
			],
		},
		hability: ["Zoto Canister"],
		gadget: [
			"Nito Cell",
			"Proximity Alarm",
		],
	},
	{
		name: "Skopós",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/k0AOat3ISkt7WMR6X4dJg/aa4596095d3861f7de24e007730e3f89/r6s-operators-badge-skopos.png",
		weapons: {
			primaryWeapon: [
				"PCX-33",
			],
			secondaryWeapon: [
				"P229",
			],
		},
		hability: ["V10 Pantheon Shells"],
		gadget: [
			"Impact Grenade",
			"Proximity Alarm"
		],
	},
	{
		name: "Denari",
		imageUrl: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/17XNHqqrkLQ7lYFqciEwmP/21d50fb6c296d26a47f8dd84dd19298b/r6s-operators-badge-denari.png",
		weapons: {
			primaryWeapon: [
				"Scorpion EVO 3 A1",
				"FMG-9",
			],
			secondaryWeapon: [
				"GLAIVE-12",
				"P226 MK 25",
			],
		},
		hability: ["CONECTOR T.R.I.P."],
		gadget: [
			"Observation Blocker",
			"Deployable Shield"
		],
	},
]

// Last update 22/03/2026
// Version Y11S1